<template>
  <with-actions>
    <lazy-table v-model="mail_builder_template_types" model="mail_builder_template_types" :params="params">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th>{{ 'description' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(mail_builder_template_type, idx) in mail_builder_template_types">
            <router-link
              :to="{
                name: 'mail_builder_edit',
                params: { mail_builder_template_type_id: mail_builder_template_type.id }
              }"
              tag="td"
              :key="mail_builder_template_type.id"
              role="button"
              >{{ mail_builder_template_type.name }}</router-link
            >
            <td>
              <span>{{ mail_builder_template_type.description.substr(0, 100) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
// @ts-check
import Alerts from '@/utils/alerts';

/**
 * Its on purpose that there is no create or delete functionallity.
 * As any template needs work in the API anyway (to handle liquids, make HTML and such) - Any major changes need to involve an developer anyway
 */
export default {
  data() {
    return {
      mail_builder_template_types: [],
      params: {
        fields: {
          mail_builder_template_types: 'name,description'
        }
      }
    };
  },
  methods: {
    set_breadcrumbs() {
      const breadcrumbs = [
        { to: { name: 'settings_index' }, text: this.$t('settings') },
        {
          to: { name: 'mail_builders' },
          text: this.$t('routes_mail_builders')
        }
      ];
      this.setBreadcrumbs(breadcrumbs);
    }
  },
  created() {
    this.set_breadcrumbs();
  }
};
</script>
